import { SHOW_DELETE_DIALOG, HIDE_DIALOG, SHOW_LOADER, HIDE_LOADER, REMEMBER_LIST, SET_LIST_DATA, SET_TIMER_VALUE, SITE_NEW_CONTENT, CLEAR_TIMER_VALUE } from './mutations_types'
import { DELETE_HANDLER, DELETE_SINGLE_RECORD_HANDLER, RELOAD_NEW_CONTENT, USERS, PROJECTS, WORKTYPES, ACTIVITIES, HOLIDAYS, GET_RUNNING, GETCURRENTPROJECTS } from './actions_types'
import { api } from '../plugins/axios_settings'
import moment from 'moment'
const state = {
  showDialog: false,
  deletePayload: {},
  showLoader: false,
  rememberOrder: {},
  ticketState: 0,
  isNewContentAvaliable: false,
  activeSW: {},
  // FORM TYPES
  FORM_TYPE: {
    TEXT: 'text',
    TEXTAREA: 'textarea',
    CHECKBOX: 'checkbox',
    SELECT: 'select',
    AUTO_COMPLETE: 'auto_complete',
    COMBOBOX: 'combobox',
    DATE: 'date',
    PASSWORD: 'password',
    NUMBER: 'number',
    DATEPICKER: 'datepicker',
    QUICKADD: 'quickadd',
    TIMEPICKER: 'timepicker',
    FILES: 'files',
    ALERT: 'alert',
    COLORPICKER: 'color',
    BUTTON: 'btn',
    BTNDROPDOWN: 'btnDropdown',
    RADIO: 'radio'
  },
  // ALL THE INDEX PAGE USES
  WORKTYPES_INDEX: {},
  HOLIDAYS_INDEX: {},
  ACTIVITIES_INDEX: {},
  GENERAL_ACTIVITIES_INDEX: {},
  MEMBERS_INDEX: {},
  USERS_INDEX: {},
  PROJECTS_INDEX: {},
  // Common lists
  listOfUsers: [],
  listOfProjects: [],
  listOfCurrentProjects: [],
  listOfWorktypes: [],
  listOfActivities: [],
  listOfHolidays: [],
  // Stamp timer
  isTimerRunning: false,
  currentRunningTime: ''
}

const getters = {
  formType (state) {
    return state.FORM_TYPE
  },
  showDialog (state) {
    return state.showDialog
  },
  deletePayload (state) {
    return state.deletePayload
  },
  timerData (state) {
    return { isTimeRunning: state.isTimerRunning, runningTime: state.currentRunningTime }
  },
  getUsers (state) {
    return state.listOfUsers
  },
  getProjects (state) {
    return state.listOfProjects
  },
  getCurrentProjects (state) {
    return state.listOfCurrentProjects
  },
  getWorktypes (state) {
    return state.listOfWorktypes
  },
  getActivities (state) {
    return state.listOfActivities
  },
  getHolidays (state) {
    return state.listOfHolidays
  },
  getNewContentAvailable (state) {
    return state.isNewContentAvaliable
  }
}

const actions = {
  [DELETE_HANDLER] ({ commit }, model) {
    return new Promise((resolve, reject) => {
      let modelObj = { data: { ids: model.ids } }
      api.delete(model.url, modelObj).then(() => { resolve() }).catch((error) => { reject(error) })
    })
  },
  [DELETE_SINGLE_RECORD_HANDLER] ({ commit }, model) {
    return new Promise((resolve, reject) => {
      api.delete(model.url).then(() => { resolve() }).catch((error) => { reject(error) })
    })
  },
  [USERS] ({ commit }) {
    return new Promise((resolve, reject) => {
      api.get('users')
        .then((response) => {
          let model = { type: 'listOfUsers', data: response.data }
          commit(SET_LIST_DATA, model)
          resolve()
        })
    })
  },
  [PROJECTS] ({ commit }) {
    return new Promise((resolve, reject) => {
      api.get('projects')
        .then((response) => {
          let model = { type: 'listOfProjects', data: response.data }
          commit(SET_LIST_DATA, model)
          resolve()
        })
    })
  },
  [GETCURRENTPROJECTS] ({ commit }) {
    return new Promise((resolve, reject) => {
      let date = moment().format('MM-DD-YYYY')
      api.get(`projects/get_current_projects?date=${date}`)
        .then((response) => {
          let model = { type: 'listOfCurrentProjects', data: response.data }
          commit(SET_LIST_DATA, model)
          resolve()
        })
    })
  },
  [WORKTYPES] ({ commit }) {
    return new Promise((resolve, reject) => {
      api.get('worktypes/get_only_active')
        .then((response) => {
          let model = { type: 'listOfWorktypes', data: response.data }
          commit(SET_LIST_DATA, model)
          resolve()
        })
    })
  },
  [ACTIVITIES] ({ commit }) {
    return new Promise((resolve, reject) => {
      api.get('activities')
        .then((response) => {
          let model = { type: 'listOfActivities', data: response.data }
          commit(SET_LIST_DATA, model)
          resolve()
        })
    })
  },
  [HOLIDAYS] ({ commit }) {
    return new Promise((resolve, reject) => {
      api.get('holidays')
        .then((response) => {
          let model = { type: 'listOfHolidays', data: response.data }
          commit(SET_LIST_DATA, model)
          resolve()
        })
    })
  },
  [RELOAD_NEW_CONTENT] ({ state, commit }) {
    state.activeSW.waiting.postMessage({ action: 'skipWaiting' })
    commit(RELOAD_NEW_CONTENT)
  },
  [GET_RUNNING] ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      api.get(`stamptimes/get_running/${userId}`)
        .then(response => {
          if (response.data) {
            let model = response.data
            if (model && model.start_at) {
              let time = getCalculatedTime(model.start_at)
              let getModel = { time, ...model }
              resolve(getModel)
            }
          }
        })
        .catch((ex) => {
          reject(ex)
        })
    })
  }
}

const mutations = {
  [SHOW_DELETE_DIALOG]: (state, data) => {
    state.deletePayload = data
    state.showDialog = true
  },
  [HIDE_DIALOG]: (state) => {
    state.showDialog = false
  },
  [SHOW_LOADER]: (state) => {
    state.showLoader = true
  },
  [HIDE_LOADER]: (state) => {
    state.showLoader = false
  },
  [REMEMBER_LIST]: (state, pagination) => {
    state[pagination.type] = pagination.data
  },
  [SET_LIST_DATA] (state, obj) {
    state[obj.type] = obj.data
  },
  [SET_TIMER_VALUE] (state, time) {
    state.isTimerRunning = true
    state.currentRunningTime = time
  },
  [CLEAR_TIMER_VALUE] (state) {
    state.isTimerRunning = false
    state.currentRunningTime = ''
  },
  [SITE_NEW_CONTENT]: (state, data) => {
    state.activeSW = data
    state.isNewContentAvaliable = true
  },
  [RELOAD_NEW_CONTENT]: (state) => {
    state.isNewContentAvaliable = false
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}

const getCalculatedTime = (startat) => {
  var current = moment()
  var startAt = moment(startat, 'YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DDTHH:mm:ss')
  var durationStartToCurrent = moment.duration(current.diff(startAt)).asHours()
  // DURATION B/W CURRENT AND START TIME - (DURATION B/W CURRENT AND START TIME)
  var difference = (durationStartToCurrent - (durationStartToCurrent))
  var finalTime = startAt.add(difference, 'hours').toDate()
  return finalTime
}
